import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

export function initMediaGallery() {
const sections = document.querySelectorAll('.js-media-gallery-section');
    
if (sections.length === 0) {
    return;
}
    
sections.forEach((section, index) => {
const blockKey = section.dataset.blockKey;
const pageKey = section.dataset.pageKey;
const culture = section.dataset.culture;
const breadcrumbsContainer = section.querySelector('.js-breadcrumbs-container');
const breadcrumbsList = section.querySelector('.js-breadcrumbs');
const itemsContainer = section.querySelector('.js-media-items-container');
const backButton = section.querySelector('.js-back-button');
        
if (!itemsContainer) {
    return;
}
        
        let currentLightbox = null;
        let currentBreadcrumbs = [];
        let allMediaData = null; // Store all media data from API
        let rootItemsData = null; // Store root items from API
        let isDataLoaded = false; // Track if data has been loaded

    // Load all media data on initialization
    loadAllMediaData();

    // Function to load all media data in a single API call
    function loadAllMediaData() {
        if (!pageKey || !blockKey || !culture) {
            isDataLoaded = true;
            renderEmptyState();
            return;
        }

        const url = new URL('/api/media/all-data', window.location.origin);
        url.searchParams.append('pageKey', pageKey);
        url.searchParams.append('blockKey', blockKey);
        url.searchParams.append('culture', culture);

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to load media data: ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                allMediaData = data.folders;
                rootItemsData = data.rootItems || [];
                isDataLoaded = true;
                
                // Render root items with initial animation
                renderRootItemsWithAnimation();
            })
            .catch(error => {
                console.error('Error loading media data:', error);
                isDataLoaded = true;
                renderEmptyState();
            });
    }

    // Handle all clicks on the section
    section.addEventListener('click', (e) => {
        // Check for back button
        const backBtn = e.target.closest('.js-back-button');
        if (backBtn) {
            e.preventDefault();
            e.stopPropagation();
            goBack();
            return;
        }
        
        // Check for folder link
        const folderLink = e.target.closest('.js-folder-link');
        if (folderLink) {
            e.preventDefault();
            e.stopPropagation();
                
            const folderId = folderLink.dataset.folderId;
            if (folderId) {
                loadFolder(folderId);
            }
            return;
        }

        // Check for breadcrumb link
        const breadcrumbLink = e.target.closest('.js-breadcrumb-link');
        if (breadcrumbLink) {
            e.preventDefault();
            e.stopPropagation();
                
            const folderId = breadcrumbLink.dataset.folderId;
            if (folderId === 'root') {
                loadRoot();
            } else if (folderId) {
                loadFolder(folderId);
            }
            return;
        }
    }); // Use normal bubbling phase for event handling

        function goBack() {
            // If we have breadcrumbs, go to the parent folder
            if (currentBreadcrumbs.length > 1) {
                // Get the parent folder (second to last in breadcrumbs)
                const parentFolderId = currentBreadcrumbs[currentBreadcrumbs.length - 2].id;
                if (parentFolderId === 'root') {
                    loadRoot();
                } else {
                    loadFolder(parentFolderId);
                }
            } else {
                // If we're one level deep, go back to root
                loadRoot();
            }
        }
        
        function updateBackButton() {
            if (backButton) {
                if (currentBreadcrumbs.length > 0) {
                    backButton.disabled = false;
                } else {
                    backButton.disabled = true;
                }
            }
        }

        function loadFolder(folderId) {
            // Use cached data instead of API call
            if (!allMediaData || !allMediaData[folderId]) {
                console.error('Folder data not found:', folderId);
                return;
            }

            const folderData = allMediaData[folderId];
            
            // Store current height
            const currentHeight = itemsContainer.offsetHeight;
            itemsContainer.style.height = `${currentHeight}px`;
            
            // Add fade-out animation
            itemsContainer.classList.add('fade-out');
            
            // Wait for fade-out animation to complete
            setTimeout(() => {
                // Temporarily show content off-screen to measure its height
                const tempContainer = document.createElement('div');
                tempContainer.style.cssText = 'position: absolute; visibility: hidden; width: ' + itemsContainer.offsetWidth + 'px;';
                tempContainer.innerHTML = renderFolderContent(folderData);
                itemsContainer.parentElement.appendChild(tempContainer);
                
                // Get the natural height of new content
                const newHeight = tempContainer.offsetHeight;
                itemsContainer.parentElement.removeChild(tempContainer);
                
                // Insert the rendered HTML
                itemsContainer.innerHTML = renderFolderContent(folderData);
                currentBreadcrumbs = folderData.breadcrumbs || [];
                renderBreadcrumbs(currentBreadcrumbs);
                updateBackButton();
                
                itemsContainer.classList.remove('fade-out');
                
                // Animate to new height
                requestAnimationFrame(() => {
                    itemsContainer.style.height = `${newHeight}px`;
                    
                    // Add fade-in animation
                    itemsContainer.classList.add('fade-in');
                    
                    // After transition completes, remove fixed height
                    setTimeout(() => {
                        itemsContainer.style.height = '';
                        itemsContainer.classList.remove('fade-in');
                    }, 400);
                });
                
                // Reinitialize lightbox for new images
                if (currentLightbox) {
                    currentLightbox.destroy();
                }
                initLightbox();

                // Trigger lazy loading for new images
                if (window.lazySizes) {
                    window.lazySizes.autoSizer.checkElems();
                }
            }, 250);
        }

        function loadRoot() {
            // Store current height
            const currentHeight = itemsContainer.offsetHeight;
            itemsContainer.style.height = `${currentHeight}px`;
            
            // Add fade-out animation
            itemsContainer.classList.add('fade-out');
            
            // Wait for fade-out animation to complete
            setTimeout(() => {
                // Temporarily show content off-screen to measure its height
                const tempContainer = document.createElement('div');
                tempContainer.style.cssText = 'position: absolute; visibility: hidden; width: ' + itemsContainer.offsetWidth + 'px;';
                const rootContent = renderRootItems(false);
                tempContainer.innerHTML = rootContent;
                itemsContainer.parentElement.appendChild(tempContainer);
                
                // Get the natural height of root content
                const newHeight = tempContainer.offsetHeight;
                itemsContainer.parentElement.removeChild(tempContainer);
                
                // Restore root content
                itemsContainer.innerHTML = rootContent;
                breadcrumbsContainer.classList.add('hidden');
                currentBreadcrumbs = [];
                updateBackButton();
                
                itemsContainer.classList.remove('fade-out');
                
                // Animate to new height
                requestAnimationFrame(() => {
                    itemsContainer.style.height = `${newHeight}px`;
                    
                    // Add fade-in animation
                    itemsContainer.classList.add('fade-in');
                    
                    // After transition completes, remove fixed height
                    setTimeout(() => {
                        itemsContainer.style.height = '';
                        itemsContainer.classList.remove('fade-in');
                    }, 400);
                });
                
                // Reinitialize lightbox
                if (currentLightbox) {
                    currentLightbox.destroy();
                }
                initLightbox();

                // Smooth scroll to section
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 250);
        }

        // Shared function to render items (folders and images)
        function renderItems(items) {
            if (!items || items.length === 0) {
                return `<div class="text-center py-40"><p class="text-black/48">No items found.</p></div>`;
            }

            let html = '<div class="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-16 clamp-[gap-y,20,40] js-media-gallery">';

            items.forEach(item => {
                if (item.type === 'folder') {
                    const itemCountText = item.itemCount === 1 ? `1 ${dictionary.item}` : `${item.itemCount} ${dictionary.items}`;
                    html += `
                        <div>
                            <div class="font-bold flex items-center gap-30 clamp-[mb,10,20] clamp-[text,17px,19px]">
                                ${escapeHtml(item.name)}
                            </div>
                            <a href="#"
                               data-folder-id="${item.id}"
                               class="js-folder-link block group">
                                <div class="flex items-center gap-8 aspect-[416/259] bg-[#F1EEEA] justify-center rounded-[4px] transition-opacity duration-300">
                                    <div class="flex flex-col gap-12 items-center">
                                        <svg class="size-[40%] group-hover:scale-[1.05] transition duration-300 text-black/60" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path fill="currentColor" d="M0 96C0 60.7 28.7 32 64 32l132.1 0c19.1 0 37.4 7.6 50.9 21.1L289.9 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-161.4 0c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7L64 80z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="mt-12 text-black/65 clamp-[text,13px,15px]">
                                    ${itemCountText}
                                </div>
                            </a>
                        </div>
                    `;
                } else if (item.type === 'image') {
                    const fileInfo = item.fileSize && item.extension ? `${item.fileSize} | ${item.extension}` : '';
                    html += `
                        <div class='flex flex-col justify-between'>
                            <div class="clamp-[mb,10,20] clamp-[text,17px,19px]">
                                <p class="font-bold">${escapeHtml(item.name)}</p>
                            </div>
                            <div>
                                <div class="relative group">
                                    <a href="${escapeHtml(item.fullUrl)}"
                                        class="glightbox block"
                                        data-gallery="media-gallery-${blockKey}"
                                        data-title="${escapeHtml(item.name)}"
                                        data-description="${escapeHtml(fileInfo)}">
                                        <div class="relative overflow-hidden rounded-[4px] bg-[#F1EEEA]">
                                            <img src="${escapeHtml(item.thumbnailUrl)}"
                                                    data-src="${escapeHtml(item.largeUrl)}"
                                                    alt="${escapeHtml(item.name)}"
                                                    width="308" height="192"
                                                    class="rounded-[4px] lazyload transition duration-300 w-full group-hover:scale-[1.05]" />
                                        </div>
                                    </a>
                                    <a href="${escapeHtml(item.url)}"
                                        download="${escapeHtml(item.name)}"
                                        class="absolute top-8 right-8 bg-white/90 group/a transition opacity-0 group-hover:opacity-80 hover:opacity-100 duration-300 p-8 shadow-sm rounded-[4px]"
                                        title="${dictionary.downloadImage}"
                                        aria-label="${dictionary.download} ${escapeHtml(item.name)}"
                                        onclick="event.stopPropagation();">
                                        <svg aria-hidden="true" class="size-20 shrink-0 [&_path]:stroke-[#858585] [&_path]:group-hover/a:stroke-gold [&_path]:transition [&_path]:duration-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 15V3M12 15L7 10M12 15L17 10M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </a>
                                </div>
                                ${fileInfo ? `<div class="mt-12 text-black/65 clamp-[text,13px,15px]">${escapeHtml(fileInfo)}</div>` : ''}
                            </div>
                        </div>
                    `;
                }
            });

            html += '</div>';
            return html;
        }

        function renderRootItems(shouldAnimate = true) {
            const html = renderItems(rootItemsData);
            
            if (shouldAnimate) {
                itemsContainer.innerHTML = html;
                
                // Reinitialize lightbox
                if (currentLightbox) {
                    currentLightbox.destroy();
                }
                initLightbox();

                // Trigger lazy loading
                if (window.lazySizes) {
                    window.lazySizes.autoSizer.checkElems();
                }
            }
            
            return html;
        }

        function renderRootItemsWithAnimation() {
            const html = renderItems(rootItemsData);
            
            // Set initial opacity for fade-in effect
            itemsContainer.style.opacity = '0';
            itemsContainer.innerHTML = html;
            
            // Measure natural height
            const naturalHeight = itemsContainer.offsetHeight;
            itemsContainer.style.height = `${naturalHeight}px`;
            
            // Trigger fade-in animation
            requestAnimationFrame(() => {
                itemsContainer.classList.add('fade-in');
                
                // After transition completes, remove fixed height and class
                setTimeout(() => {
                    itemsContainer.style.height = '';
                    itemsContainer.style.opacity = '';
                    itemsContainer.classList.remove('fade-in');
                }, 400);
            });
            
            // Reinitialize lightbox
            if (currentLightbox) {
                currentLightbox.destroy();
            }
            initLightbox();

            // Trigger lazy loading
            if (window.lazySizes) {
                window.lazySizes.autoSizer.checkElems();
            }
        }

        function renderEmptyState() {
            itemsContainer.innerHTML = `<div class="text-center py-40"><p class="text-black/48">${window.dictionary.noItemsFound}</p></div>`;
        }

        function renderFolderContent(folderData) {
            const items = [...(folderData.folders || []), ...(folderData.images || [])];
            return renderItems(items);
        }

        function renderBreadcrumbs(breadcrumbs) {
            if (!breadcrumbs || breadcrumbs.length === 0) {
                breadcrumbsContainer.classList.add('hidden');
                return;
            }

            breadcrumbsContainer.classList.remove('hidden');
            
            let html = '';

            breadcrumbs.forEach((crumb, index) => {
                const isFirst = index === 0;
                const isLast = index === breadcrumbs.length - 1;
                html += `
                    <li class="flex items-center gap-8">
                        ${!isFirst ? '<span class="text-black/48">/</span>' : ''}
                        <a href="#" data-folder-id="${crumb.id}" class="js-breadcrumb-link hover:text-gold duration-300 transition-text ${isLast ? 'text-black/40' : ''}">
                            ${escapeHtml(crumb.name)}
                        </a>
                    </li>
                `;
                
            });

            breadcrumbsList.innerHTML = html;
        }

        function initLightbox() {
            const lightboxElements = section.querySelectorAll('.glightbox');
            if (lightboxElements.length > 0) {
                // Build elements array with inline content for GLightbox
                const elements = Array.from(lightboxElements).map(el => {
                    const imageUrl = el.getAttribute('href');
                    const title = el.getAttribute('data-title') || '';
                    const description = el.getAttribute('data-description') || '';
                    
                    // Compose custom HTML content with image, description, and download button
                    const inlineContent = `
                        <div class="glightbox-custom-content">
                            <div class="glightbox-image-wrapper">
                                <img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(title)}" class="glightbox-image" />
                            </div>
                            <div class="glightbox-custom-desc">
                                <div class="glightbox-desc-text">
                                    ${title ? `<h3 class="glightbox-title">${escapeHtml(title)}</h3>` : ''}
                                    ${description ? `<p class="glightbox-description">${escapeHtml(description)}</p>` : ''}
                                </div>
                                <a href="${escapeHtml(imageUrl)}" 
                                   download 
                                   class="glightbox-download-btn cursor-pointer [&_path]:stroke-[#858585] hover:[&_path]:stroke-gold [&_path]:transition [&_path]:duration-300"
                                   title="Download"
                                   aria-label="Download">
                                    <svg aria-hidden="true" class="shrink-0" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 15V3M12 15L7 10M12 15L17 10M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    `;
                    
                    return {
                        content: inlineContent,
                        type: 'inline'
                    };
                });

                currentLightbox = GLightbox({
                    elements: elements,
                    touchNavigation: true,
                    keyboardNavigation: true,
                    closeOnOutsideClick: true,
                    height:'auto',
                    loop: true,
                    autoplayVideos: false,
                    zoomable: false, // Disable zoom for inline content
                    draggable: true,
                    openEffect: 'fade',
                    closeEffect: 'fade'
                });

                // Add custom class to lightbox container when it opens
                currentLightbox.on('open', () => {
                    setTimeout(() => {
                        const glightboxContainer = document.querySelector('.glightbox-container');
                        if (glightboxContainer) {
                            glightboxContainer.classList.add('media-gallery-lightbox');
                        }
                    }, 50);
                });

                // Add click handlers to open lightbox at correct index
                lightboxElements.forEach((el, index) => {
                    el.addEventListener('click', (e) => {
                        e.preventDefault();
                        currentLightbox.openAt(index);
                    });
                });
            }
        }

        function escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        }
    });
}


